import { __assign, __rest } from "tslib";
import React from 'react';
import cx from 'classnames';
import bcx from 'bem-classname';
export var HeaderBalance = function (props) {
    var componentClass = 'header';
    var elementClass = 'balance';
    var className = props.className, children = props.children, otherProps = __rest(props, ["className", "children"]);
    var classes = cx(className, bcx(componentClass, elementClass));
    return (React.createElement("div", __assign({}, otherProps, { className: classes }), children));
};
//# sourceMappingURL=HeaderBalance.js.map